
/** the type of popup modal to display */
export enum PopUpWindowType {
    /** normal text modal */
    MessageBox = 0,
    /** urgent text modal */
    ImportantMessage = 1
}
